import { createApp, type App, type Component } from 'vue';
import customAxios from '@/bootstarp/request';
import { createPinia } from 'pinia';
import { checkLogin, init } from '@/configs/coalEduAuth';
import './setRem';

import '@/assets/styles/reset.css';
import 'element-plus/theme-chalk/base.css';
import 'element-plus/theme-chalk/el-message.css';
import 'element-plus/theme-chalk/el-message-box.css';
import '@/assets/styles/common.scss';
import { siteURL } from '@/configs/Constant';
import { preloadImages } from '@/utils/preloadImage';
import { setupScrollAnimate } from '@/directives/scrollAnimate';

declare global {
  interface Window {
    axios: typeof customAxios;
    removeAppLoading?: () => void;
  }
}

export interface StartupOptions<App> {
  beforeCreate?: () => void;
  created?: (app: App) => void;
  beforeMount?: (app: App) => void;
  mounted?: (app: App) => void;
  preloadImages?: string[];
}

function initIEBrowser() {
  const ua = navigator.userAgent;
  const isIE =
    ua.indexOf('MSIE') > -1 ||
    // IE11 版本检测（Trident 引擎）
    (ua.indexOf('Trident') > -1 && ua.indexOf('rv') > -1);

  let canHideProperty = true;
  try {
    Object.defineProperty({}, '_', {
      value: 'x',
    });
  } catch (e) {
    canHideProperty = false;
  }

  const supportsModernJS =
    typeof Object.defineProperties === 'function' &&
    canHideProperty &&
    typeof Promise !== 'undefined' &&
    typeof Symbol !== 'undefined';

  // 如果是 IE 浏览器或不支持现代 JavaScript 特性，跳转到升级页面
  if (isIE || !supportsModernJS) {
    window.location.href = siteURL + 'html/forie.html';
  }
}

export default function withStartUpApp(component: Component, options: StartupOptions<App> = {}) {
  initIEBrowser();
  // 创建前
  options.beforeCreate?.();

  if (options.preloadImages && options.preloadImages.length > 0) {
    preloadImages(options.preloadImages).catch((error) => {
      console.warn('Image preload failed:', error);
    });
  }

  const app = createApp(component);

  options.created?.(app);
  options.beforeMount?.(app);
  window.axios = customAxios;
  app.use(createPinia());

  setupScrollAnimate(app);

  // 必须先完成登录态检查/换票，再挂载页面，避免业务请求仍携带旧 Cookie
  void (async () => {
    try {
      await checkLogin();
    } catch (error) {
      console.error('启动时检查登录状态失败:', error);
    }

    try {
      await init();
    } catch (error) {
      console.error('启动初始化失败:', error);
    }

    app.mount('#app');
    options.mounted?.(app);

    if (typeof window.removeAppLoading === 'function') {
      window.removeAppLoading();
    }
  })();

  return app;
}
